import Questions from '../../../../components/questions/questions.desktop';
import questionsVisShortDescription from './questions-vis-short-description';

export default questionsVisShortDescription(Questions);
